import React from "react";
import PropTypes from "prop-types";
//Material imports
import Grid from "@mui/material/Grid";
//Limitless imports
import MultilineTextField from "@limitless/modern/inputs/multiline-text-field/MultilineTextField";
const BasicFreeTextInput = ({
  content,
  onValueChange,
  values
}) => {
  const {
    stateCaptureKey,
    label,
    placeholder,
    rows,
    fullWidth = false
  } = content;
  const {
    value = "",
    errorMessage = ""
  } = values ? values[stateCaptureKey] : {};
  return /*#__PURE__*/React.createElement(Grid, {
    container: true,
    item: true,
    xs: 12
  }, /*#__PURE__*/React.createElement(Grid, {
    sx: {
      maxWidth: fullWidth ? "100%" : 440
    },
    container: true,
    mt: 2,
    mb: 2,
    mr: "25px"
  }, /*#__PURE__*/React.createElement(MultilineTextField, {
    fullWidth: true,
    multiline: true,
    rows: rows,
    id: `${label.toLowerCase()}Input`,
    label: label,
    onChange: e => onValueChange && onValueChange(stateCaptureKey, e.target.value),
    value: value,
    required: true,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : label,
    error: errorMessage ? true : false,
    errorText: errorMessage
  })));
};
export default BasicFreeTextInput;
BasicFreeTextInput.propTypes = {
  content: PropTypes.object.isRequired,
  onValueChange: PropTypes.func,
  values: PropTypes.object
};